import React from 'react';
import { Grid } from 'react-loader-spinner';

export function CustomLoader({ visible = false }) {
  if (!visible) return null;

  return (
    <div className="loader" aria-busy={visible}>
      <Grid
        height={100}
        width={100}
        color="#3a0031"
        ariaLabel="loading"
      />
    </div>
  );
}

export default CustomLoader;
